import Button from "components/Button";

import styles from "../styles.module.scss";

type Props = {
  onClose?: () => void;
  onClick?: () => void;
  title?: string;
  buttonText?: string;
  description?: string;
  buttonText2?: string;
  onClick2?: () => void;
};

const NoticeContent = ({ onClose, onClick, title, buttonText, description, buttonText2, onClick2 }: Props) => {
  const handleClick = () => {
    onClick?.();
    onClose?.();
  };

  const handleClick2 = () => {
    onClick2?.();
    onClose?.();
  };

  return (
    <>
      {!!title && <p className={styles.modalNoticeTitle}>{title}</p>}

      {!!description && <p className={styles.modalNoticeDescription}>{description}</p>}

      <div className={styles.modalNoticeButtons}>
        {!!buttonText2 && (
          <Button variant="secondary" className={styles.modalNoticeButton} onClick={handleClick2}>
            {buttonText2}
          </Button>
        )}

        {!!buttonText && (
          <Button variant="primary" className={styles.modalNoticeButton} onClick={handleClick}>
            {buttonText}
          </Button>
        )}
      </div>
    </>
  );
};

export default NoticeContent;
